import { render } from "./BecomeATutorComponent.vue?vue&type=template&id=13f26274&scoped=true"
import script from "./BecomeATutorComponent.vue?vue&type=script&lang=js"
export * from "./BecomeATutorComponent.vue?vue&type=script&lang=js"

import "./BecomeATutorComponent.vue?vue&type=style&index=0&id=13f26274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f26274"]])

export default __exports__